import create from 'zustand';

type Store = {
  isEditMode: boolean;
  setEditModeToggle: () => void;
  setEditModeClose: () => void;
};

/**
 * 編集モードのストア
 */
const useEditMode = create<Store>(set => ({
  isEditMode: false,
  setEditModeToggle: () => set(state => ({ isEditMode: !state.isEditMode })),
  setEditModeClose: () => set({ isEditMode: false }),
}));

export default useEditMode;